import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useCustomHistory } from '../../router/navigation';

const getSkipLinksWithI18n = (t) => [
  {
    id: 'main-content',
    label: t('Skip to main content'),
  },
  {
    id: 'footer',
    label: t('Skip to footer'),
  },
];

const SkipLinksContainer = styled.div(() => ({
  position: 'relative',
}));

const StyledSkipLink = styled.a(({ theme }) =>
  theme.withMedia({
    position: 'absolute',
    top: '-2000px',
    padding: '8px 25px',
    textDecoration: 'none',
    color: theme.styleguideColors.contentOnFill,
    background: theme.styleguideColors.fillSecondaryBlueHover,

    zIndex: 100,
    ':focus': {
      top: '20px',
      left: '20px',
    },
  })
);

interface LinkItemProps {
  to: string;
  title: string;
}

const LinkItem = ({ to, title }: LinkItemProps) => {
  const { location } = useCustomHistory();
  const { pathname, search } = location;
  const href = `${pathname}${search}#${to}`;

  const handleSkipLinkClick = () => {
    document.getElementById(to)?.focus();
  };

  return (
    <StyledSkipLink href={href} onClick={handleSkipLinkClick}>
      {title}
    </StyledSkipLink>
  );
};

export const SkipLinks = () => {
  const { t } = useTranslation();
  const skipLinks = getSkipLinksWithI18n(t);
  return (
    <SkipLinksContainer aria-label="Skip links">
      {skipLinks.map(({ id, label }) => (
        <LinkItem key={id} title={label} to={id} />
      ))}
    </SkipLinksContainer>
  );
};

export default SkipLinks;
